<template>
  <v-snackbar v-model="modelValue" :timeout="timeout" bottom left>
    {{ text }}

    <template #action v-if="action">
      <v-btn class="new-btn py-2 px-4" text color="primary" :loading="loading" @click="handleAction">
        {{ action.text }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { Method } from '@/_typedefs'

export default {
  data() {
    return {
      modelValue: false,
      /** @type {number?} */
      timeout: null,
      /** @type {string?} */
      text: null,
      /** @type {{text: string, fn: () => void | Promise<void>}?} */
      action: null,
      loading: false,
    }
  },
  methods: {
    /** @type {Method<timeout: number, text: string, action?: {text: string, fn: () => void | Promise<void>}>} */
    show(timeout, text, action) {
      this.timeout = timeout
      this.text = text
      this.action = action
      this.modelValue = true
    },
    async handleAction() {
      try {
        this.loading = true
        await Promise.resolve(this.action?.fn())
        this.modelValue = false
      } catch (error) {
        this.$root.error(error)
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    modelValue(val) {
      if (!val) {
        this.timeout = null
        this.text = null
        this.action = null
      }
    },
  },
}
</script>

<style></style>
